const isEnvProduction = (env) => env.NODE_ENV === "production";

function log(message, ...optionalParams) {
    if (!isEnvProduction(process.env)) {
        console.log(message, ...optionalParams);
    }
}

function error(message, ...optionalParams) {
    if (!isEnvProduction(process.env)) {
        console.error(message, ...optionalParams);
    }
}

export const logger = {
    log,
    error,
};